import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';
import * as moment from 'moment';
import { AppConfigService } from '../../app-config.service';

@Pipe({
  name: 'hourFloorMinute',
  standalone: false
})
export class HourFloorMinutePipe implements PipeTransform {
  private readonly FR_FORMAT = 'H [h] mm';
  private readonly EN_FORMAT = 'h:mm A';

  constructor(private readonly _appConfigService: AppConfigService) {}

  transform(
    date: string | Date,
    langue: string = get(this._appConfigService, 'configData.contexteEnvironnement.langue', 'fr')
  ): any {
    moment.locale(langue);
    let formattedHourFloorMinute = '-';

    if (date) {
      const floorMinutes = Math.floor(moment(date).minute() / 10) * 10;
      formattedHourFloorMinute = moment(date)
        .minute(floorMinutes)
        .format(langue === 'fr' ? this.FR_FORMAT : this.EN_FORMAT)
        .replace('am', 'AM')
        .replace('pm', 'PM');
    }

    return formattedHourFloorMinute;
  }
}
